/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Verdict_Ready_BodyInputs */

const cs_import_verdict_ready_body = /** @type {(inputs: Import_Verdict_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled vypadá v pořádku. Zkontrolujte plán níže a potvrďte import do organizace.`)
};

const en_import_verdict_ready_body = /** @type {(inputs: Import_Verdict_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry-run looks clean. Review the plan below, then commit into your organization.`)
};

/**
* | output |
* | --- |
* | "Dry-run looks clean. Review the plan below, then commit into your organization." |
*
* @param {Import_Verdict_Ready_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_verdict_ready_body = /** @type {((inputs?: Import_Verdict_Ready_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Verdict_Ready_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_verdict_ready_body(inputs)
	return cs_import_verdict_ready_body(inputs)
});